import { createHttpLink } from "@apollo/client/link/http";

export default function createClientHttpLink() {
  return createHttpLink({
    uri: process.env.REACT_APP_PPSMS_API_URL
  });
}
